"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

const InvisibilityCloak = ({
  children,
  covered,
  stretch
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)('invisibility-cloak', {
    'invisibility-cloak--covered': covered,
    'invisibility-cloak--stretch': stretch
  })
}, children);

InvisibilityCloak.propTypes = {
  children: _propTypes.default.node,
  covered: _propTypes.default.bool,
  stretch: _propTypes.default.bool
};
InvisibilityCloak.defaultProps = {
  children: null,
  covered: false,
  stretch: false
};
var _default = InvisibilityCloak;
exports.default = _default;